import { useEffect, useState } from 'react';

import { fg } from '@confluence/feature-gating';

/**
 * Marketplace apps that can show at the top of the page in the ATL General web panel.
 * This height of the panel is set in useATLGeneralWebPanelObserver and the event atlGeneralWebPanelHeightUpdated is emitted there
 *
 * @returns The height of the ATL General web panel in pixels.
 */
export const useGeneralWebPanelHeight = (): number => {
	const [panelHeight, setPanelHeight] = useState<number>(0);

	useEffect(() => {
		if (!fg('confluence_editor_height_when_atl_header')) {
			return;
		}

		const updateHeight = () => {
			try {
				const heightValue = getComputedStyle(document.documentElement).getPropertyValue(
					'--atl-general-webpanel-height',
				);
				const numericValue = parseInt(heightValue, 10);

				setPanelHeight(!isNaN(numericValue) && numericValue >= 0 ? numericValue : 0);
			} catch (e) {
				setPanelHeight(0);
			}
		};

		updateHeight();
		// Listen for height changes
		document.addEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
		return () => {
			document.removeEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
		};
	}, []);

	return panelHeight;
};
